import { Helmet } from 'react-helmet-async';
import React from 'react';
import requireAuth from '../../../../lib/requireAuth.jsx';
import withRouterParams from '../../../../lib/withRouterParams.jsx';

import StepMilestonesFormContainer from '../../../../containers/projects/ChangeStrategyFormContainers/StepMilestonesFormContainer.jsx';

const NewChangeStrategyStepMilestones = ({ projectId, slug }) => (
  <>
    <Helmet>
      <title>New Change Strategy | ChangeSync</title>
    </Helmet>
    <StepMilestonesFormContainer projectId={projectId} slug={slug} />
  </>
);

NewChangeStrategyStepMilestones.getInitialProps = ({ query }) => ({
  slug: query.slug,
  projectId: Number(query.projectId),
});

export default requireAuth(withRouterParams(NewChangeStrategyStepMilestones));
